export default __webpack_public_path__ + "static/media/traffic.6d54bbac.png";